import $ from "jquery";
import produce from "immer";
import { debounce } from "lodash";
import I18n from "i18n.js.erb";
import {
    addHtmlElementClass,
    artworkByLocale,
    compareStrings,
    convertLanguage,
    DEPLOYMENT_IN_PROGRESS_ERROR_MESSAGE,
    IDEOGRAMS_LANGUAGES,
    isDefined,
    isLanguagePresent,
    isPresent,
    ITEM_TO_ADD_ON_SUBMISSION_LIST_KEY_FOR_SESSION_STORAGE,
    ITEM_TO_GRADE_KEY_FOR_SESSION_STORAGE,
    parseLocale,
    parseStaticString2Object,
    removeHtmlElementClass,
    isInAClosingState,
    DEFAULT_PER_PAGE_PARAM,
    printReceivedSubmissionLabel,
    createFormData
} from "../utils/utils";


export const reducer = produce((draft, action) => {
    switch (action.type) {
        case 'SET_INITIAL_PARAMS':
            draft.currentUserId = action.payload.currentUser ? action.payload.currentUser.id : null
            draft.currentCompanyId = action.payload.currentUser ? action.payload.currentUser.company?.id : null
            draft.currentUserCompanyName = action.payload.currentUser && action.payload.currentUser.company ? action.payload.currentUser.company.meta_name : null
            draft.currentUserCompanyId = action.payload.currentUser && action.payload.currentUser.company ? action.payload.currentUser.company.id : null
            draft.blueprintImagesCount = action.payload.blueprintImagesCount
            draft.initialAvailableOptionsForSelect = action.payload.availableOptionsForSelect
            draft.availableOptionsForSelect = action.payload.availableOptionsForSelect
            draft.initialFilters = action.payload.initialFilters
            draft.filters = action.payload.initialFilters
            draft.submission_list = action.payload.submission_list
            draft.loggedInUser = action.payload.loggedInUser
            draft.sortingOptions = action.payload.sortingOptions
            draft.sortingDirections = action.payload.sortingDirections
            draft.translationsEditions = action.payload.translationsEditions
            draft.qualifiers_values = action.payload.qualifiers
            draft.environment = action.payload.environment
            draft.submission_list_items_ids = action.payload.submission_list_items_ids
            draft.supplementary_items_ids = action.payload.supplementary_items_ids
            draft.searchEnabled = action.payload.initialFilters !== ""
            draft.showFullScreenLoadingOverlay = false
            draft.showErrorModal = false
            draft.additionalErrorMessage = null
            draft.showSuccessModal = false
            draft.companyId = action.payload.companyId
            draft.isSuperadminUser = action.payload.is_superadmin_user
            draft.encasingsGradableOnCase = action.payload.encasingsGradableOnCase
            draft.encasingsGradableOnSleeve = action.payload.encasingsGradableOnSleeve
            draft.yuGiOhTranslations = action.payload.yuGiOhTranslations
            return
        case 'RESET_STATE':
            draft.hasLoadedAllBlueprintImages = action.payload.initialState.hasLoadedAllBlueprintImages
            draft.blueprintImages = action.payload.initialState.blueprintImages;
            draft.page = action.payload.initialState.page;
            draft.currentIndex = action.payload.initialState.currentIndex;
            return
        case 'RESET_FILTERS':
            const newFilters = { ...draft.initialFilters }
            Object.entries(newFilters).forEach(([key, value]) => {
              if (!['sort_by', 'sorting_direction', 'game_id', 'category_id'].includes(key))
                  newFilters[key] = ""
            })
            draft.filters = newFilters
            draft.availableOptionsForSelect = draft.initialAvailableOptionsForSelect
            return
        case 'INCREMENT_SEARCH_COUNT':
            draft.searchCount = draft.searchCount ? draft.searchCount + 1 : 1;
            return
        case 'LOADING':
            draft.loading = true;
            return
        case 'LOADING_COMPLETED':
            draft.loading = false;
            return
        case 'LOADING_EXPANSIONS':
            draft.loadingExpansions = true;
            return
        case 'LOADING_ERAS':
            draft.loadingEras = true;
            return
        case 'LOADING_OTHER_FILTERS':
            draft.loadingOtherFilters = true;
            return
        case 'LOADING_EXPANSIONS_COMPLETED':
            draft.loadingExpansions = false;
            return
        case 'LOADING_ERAS_COMPLETED':
            draft.loadingEras = false;
            return
        case 'LOADING_OTHER_FILTERS_COMPLETED':
            draft.loadingOtherFilters = false;
            return
        case 'LOADING_IMAGE':
            draft.loadingImage = action.payload.submissionListItemId;
            return
        case 'LOADING_IMAGES':
            draft.loadingImages = true;
            return
        case 'LOADING_IMAGES_COMPLETED':
            draft.loadingImages = false;
            draft.loadingImage = null;
            return
        case 'ENABLE_SEARCH':
            draft.searchEnabled = true;
            return
        case 'DISABLE_SEARCH':
            draft.searchEnabled = false;
            return
        case 'SET_FILTER_PARAM':
            draft.filters[action.payload.fieldName] = action.payload.fieldValue;
            for (const filterName in draft.filters)
                if (!['sort_by', 'sorting_direction'].includes(filterName) && draft.filters[filterName] !== null && draft.filters[filterName] !== "") {
                    draft.searchEnabled = true;
                    return
                }
            draft.searchEnabled = false;
            return
        case 'SET_BLUEPRINT_IMAGES_COUNT':
            draft.blueprintImagesCount = action.payload.blueprintImagesCount;
            return
        case 'APPEND_BLUEPRINT_IMAGES':
            draft.blueprintImages = draft.blueprintImages.concat(action.payload.blueprintImages);
            draft.page++;
            const perPageLimit = action.payload.perPage ? action.payload.perPage : DEFAULT_PER_PAGE_PARAM
            if (action.payload.blueprintImages.length < perPageLimit) {
                draft.hasLoadedAllBlueprintImages = true
            }
            return
        case 'RESET_BLUEPRINT_IMAGES':
            draft.hasLoadedAllBlueprintImages = false
            draft.blueprintImages = [];
            draft.page = 1;
            draft.currentIndex = -1;
            return
        case 'SET_BLUEPRINT_IMAGE':
            let newBlueprintImages = draft.blueprintImages.map((blueprintImage) => {
                if (blueprintImage.id === action.payload.blueprintImageId) {
                    const newBlueprintImage = { ...blueprintImage }
                    newBlueprintImage[action.payload.key] = action.payload.value
                    return newBlueprintImage
                } else {
                    return blueprintImage
                }
            })
            draft.blueprintImages = newBlueprintImages;
            return;
        case 'SET_BLUEPRINT_IMAGES':
            draft.blueprintImages = action.payload.blueprintImages;
            return
        case 'SET_ERAS':
            draft.availableOptionsForSelect.eras = action.payload.eras;
            return
        case 'SET_EXPANSIONS':
            draft.availableOptionsForSelect.expansions = action.payload.expansions;
            return
        case 'SET_NEW_FILTERS':
            draft.availableOptionsForSelect.release_years = action.payload.optionsForSelect.release_years
            draft.availableOptionsForSelect.copyrights = action.payload.optionsForSelect.copyrights
            draft.availableOptionsForSelect.languages = action.payload.optionsForSelect.languages
            draft.availableOptionsForSelect.rarities = action.payload.optionsForSelect.rarities
            draft.availableOptionsForSelect.versions = action.payload.optionsForSelect.versions
            draft.availableOptionsForSelect.editions = action.payload.optionsForSelect.editions
            draft.availableOptionsForSelect.illustrators = action.payload.optionsForSelect.illustrators
            draft.availableOptionsForSelect.pokedex_numbers = action.payload.optionsForSelect.pokedex_numbers
            return
        case 'SET_SUBMISSION_LIST':
            draft.submission_list = action.payload.submissionList;
            return
        case 'SET_SUBMISSION_LISTS_BY_BLUEPRINT_IMAGE':
            draft.submissionListsByBlueprintImage = action.payload.submissionLists.submission_lists;
            draft.myCollectionsByBlueprintImage = action.payload.submissionLists.my_collections;
            return
        case 'SET_AVAILABLE_SUBMISSION_LISTS':
            draft.availableSubmissionLists = action.payload.submissionLists;
            return
        case 'SET_BLUEPRINT_IMAGE_TO_ADD_ON_SUBMISSION_LIST':
            draft.blueprintImage2AddOnSubmissionlist = action.payload.blueprintImage;
            return
        case 'SET_SHOW_SUCCESS_FLASH_MESSAGE':
            draft.showSuccessFlashMessage = action.payload.show;
            return
        case 'SET_SUCCESS_FLASH_MESSAGE':
            draft.successFlashMessage = action.payload.message;
            return
        case 'SET_SHOW_ERROR_MODAL':
            draft.showErrorModal = action.payload.show;
            return
        case 'SET_ADDITIONAL_ERROR_MESSAGE':
            draft.additionalErrorMessage = action.payload.message;
            return
        case 'SET_SHOW_SUCCESS_MODAL':
            draft.showSuccessModal = action.payload.show;
            return
        case 'SET_SUCCESS_MESSAGE':
            draft.successMessage = action.payload.show;
            return
        case 'SET_BLUEPRINT_IMAGE_2_SHOW_LARGE_IMAGE':
            draft.blueprintImage2ShowLargeImage = action.payload.blueprintImage
            draft.currentIndex = action.payload.blueprintImageIndex
            return
        case 'SELECT_NEW_BLUEPRINT_IMAGE':
            draft.currentIndex = action.payload.blueprintImageIndex
            return
        case 'SET_SHOW_ZOOM_IMG':
            draft.showZoomImg = action.payload.show;
            return
        case 'OPEN_GRADING_MODAL':
            draft.frontImage = null
            draft.backImage = null
            draft.frontGradedImage = null
            draft.backGradedImage = null
            draft.currentIndex = action.payload.blueprintImageIndex
            draft.productToGrade = action.payload.product
            draft.blueprintImageToGrade = action.payload.blueprintImage
            draft.printingInformationsInAllLanguages = action.payload.printingInformationsInAllLanguages
            draft.blueprintInfo2PrintOnLabel = action.payload.printingInformationsInAllLanguages[0]
            draft.railsEnv = action.payload.railsEnv
            draft.defects = action.payload.defects
            draft.previousGrading = action.payload.previousGrading
            draft.mode = 'grading';
            return
        case 'CLEAR_GRADING_MODAL':
            draft.productToGrade = null
            draft.blueprintImageToGrade = null
            draft.printingInformationsInAllLanguages = [{ }]
            draft.blueprintInfo2PrintOnLabel = {}
            draft.previousGrading = null
            return
        case 'SET_MODE':
            draft.mode = action.payload.mode;
            return;
        case 'SET_IMAGE':
            draft[action.payload.fieldName] = action.payload.fieldValue
            return
        case 'SET_BLUEPRINT_INFO_TO_PRINT_ON_LABEL':
            draft.blueprintInfo2PrintOnLabel = action.payload.newBlueprintInfo2PrintOnLabel
            return
        case 'GO_DOWN':
            if (draft.currentIndex < draft.blueprintImages.length - 1) {
                draft.currentIndex++
            }
            return
        case 'GO_UP':
            if (draft.currentIndex >= 0) {
                draft.currentIndex--
            }
            return
        case 'SET_SHOW_FULL_SCREEN_LOADING_OVERLAY':
            draft.showFullScreenLoadingOverlay = action.payload.value
            return
        default:
            return;
    }
}, {});


export const setInitialParams = (currentUser, blueprintImagesCount, availableOptionsForSelect, initialFilters, loggedInUser, submission_list, sortingOptions, sortingDirections, translationsEditions, qualifiers, environment, submission_list_items_ids, supplementary_items_ids, companyId, is_superadmin_user, encasingsGradableOnCase, encasingsGradableOnSleeve, yuGiOhTranslations) => ({
    type: 'SET_INITIAL_PARAMS', payload: { currentUser, blueprintImagesCount, availableOptionsForSelect, initialFilters, loggedInUser, submission_list, sortingOptions, sortingDirections, translationsEditions, qualifiers, environment, submission_list_items_ids, supplementary_items_ids, companyId, is_superadmin_user, encasingsGradableOnCase, encasingsGradableOnSleeve, yuGiOhTranslations }
})

export const resetState = (initialState) => ({
    type: 'RESET_STATE', payload: { initialState }
})

export const setFilterParam = (fieldName, fieldValue) => ({
    type: 'SET_FILTER_PARAM', payload: { fieldName, fieldValue }
})

export const appendBlueprintImages = (blueprintImages, perPage) => ({
        type: 'APPEND_BLUEPRINT_IMAGES', payload: {blueprintImages, perPage}
    }
)

export const setSubmissionListItemsIds = (submission_list_items_ids) => ({
      type: 'SET_SUBMISSION_LIST_ITEMS_IDS', payload: {submission_list_items_ids}
  }
)

export const setSupplementaryItemsIds = (supplementary_items_ids) => ({
      type: 'SET_SUPPLEMENTARY_ITEMS_IDS', payload: {supplementary_items_ids}
  }
)

export const setBlueprintImagesCount = (blueprintImagesCount) => ({
      type: 'SET_BLUEPRINT_IMAGES_COUNT', payload: {blueprintImagesCount}
  }
)

export const enableSearch = () => ({
      type: 'ENABLE_SEARCH'
  }
)

export const disableSearch = () => ({
      type: 'DISABLE_SEARCH'
  }
)


export const getSubmissionListsByBlueprintImage = (blueprintImageId) => (dispatch, getState) => {
    const { companyId } = getState();
    if (isPresent(blueprintImageId)) {
        const url = `/backoffice/companies/${companyId}/submission_lists/blueprint_images/get_by/${blueprintImageId}.json`

        fetch(url, {
            method: 'GET'
        })
          .then(response => response.json())
          .then((data) => {
              dispatch(setSubmissionListsByBlueprintImage(data));
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}


export const getAvailableSubmissionLists = (setShowSubmissionListInsertionModal) => (dispatch, getState) => {
    const { availableSubmissionLists, companyId } = getState();
    if (!availableSubmissionLists || availableSubmissionLists.length === 0) {
        const url = `/backoffice/companies/${companyId}/submission_lists/all/available_for_insert.json`

        fetch(url, {
            method: 'GET'
        })
          .then(response => response.json())
          .then((data) => {
              // console.log('data: ', data)
              dispatch(setAvailableSubmissionLists(data.submission_lists));
              setShowSubmissionListInsertionModal(true);
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}


export const setImageAcquired = (blueprintImageId, acquired) => (dispatch, getState) => {
    if (isPresent(blueprintImageId) && window.confirm('Are you sure?')) {
        const { blueprintImages } = getState();
        const url = `/backoffice/blueprint_images/image/acquired/${blueprintImageId}`

        fetch(url + ".json", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ acquired: acquired }),
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then((data) => {
              let newBlueprintImages = blueprintImages.map((bi) => {
                  if (bi.id === blueprintImageId)
                      return { ...bi, acquired: data.acquired, thumb_image_url: data.thumb_image_url }
                  return bi
              })

              dispatch(setBlueprintImages(newBlueprintImages));
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}


export const addBlueprintImagesToSubmissionList = (blueprintImages, itemToAddInSubmissionList, navigateToSubmissionList, resetSubmissionLists, resetNewSubmissionList) => (dispatch, getState) =>  {
    dispatch(clearSessionStorage());
    const { encasingsGradableOnCase, companyId } = getState();

    const submissionListId = itemToAddInSubmissionList.submission_list_id;
    const body = { user_id: itemToAddInSubmissionList.user_id };
    let items = [];
    for (const blueprintImage of blueprintImages) {
        items.push(
          {
              id: blueprintImage.id,
              blueprint_id: blueprintImage.blueprint_id,
              encasing_id: blueprintImage.encasing_id,
              language: itemToAddInSubmissionList.label_language ? (itemToAddInSubmissionList.label_language === 'native' ? convertLanguage(blueprintImage.language) : 'en') : 'en',
              encasing: itemToAddInSubmissionList.encasing ? itemToAddInSubmissionList.encasing : (encasingsGradableOnCase.includes(blueprintImage.encasing_id) ? 'case' : 'sleeve'),
              requested_service: itemToAddInSubmissionList.requested_service ? itemToAddInSubmissionList.requested_service : 'grading',
              label_type: itemToAddInSubmissionList.label_type ? itemToAddInSubmissionList.label_type : 'radiant',
              quantity: itemToAddInSubmissionList.quantity ? itemToAddInSubmissionList.quantity : 1,
              supplementary_item_id: itemToAddInSubmissionList.supplementary_item_id
          })
    }
    body['items'] = items;

    const url = `/backoffice/companies/${companyId}/submission_lists/add_products_to_submission_list/${submissionListId}`;

    fetch(url, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    })
      .then((res) => {
          if (!res.ok)
              throw Error("An error occour during saving data on the database");
          else
              return res.json()
      })
      .then((data) => {
          if (resetNewSubmissionList)
              resetNewSubmissionList()

          if (navigateToSubmissionList)
            window.location = `/backoffice/companies/${companyId}/submission_lists/${submissionListId}`;
          else {
              if (resetSubmissionLists)
                  resetSubmissionLists()
              dispatch(setShowSuccessFlashMessage(true));
              dispatch(setSuccessFlashMessage(`Product successfully added to Submission List #${itemToAddInSubmissionList.submission_list_number}!`));
          }
      })
      .catch((error) => {
          console.error("ERROR:", error);
          dispatch(setShowErrorModal(true));
      });
}


export const convertSubmissionListItem = (blueprintImage, itemToAddInSubmissionList, navigateToSubmissionList) => (dispatch, getState) =>  {
    dispatch(clearSessionStorage());
    const { companyId } = getState();

    const submissionListId = itemToAddInSubmissionList.submission_list_id
    const body = {
        item: {
            id: blueprintImage.id,
            blueprint_id: blueprintImage.blueprint_id,
            language: itemToAddInSubmissionList.label_language ? itemToAddInSubmissionList.label_language : 'en',
            encasing: itemToAddInSubmissionList.encasing ? itemToAddInSubmissionList.encasing : 'case',
            requested_service: itemToAddInSubmissionList.requested_service ? itemToAddInSubmissionList.requested_service : 'grading',
            label_type: itemToAddInSubmissionList.label_type ? itemToAddInSubmissionList.label_type : 'radiant',
            quantity: itemToAddInSubmissionList.quantity ? itemToAddInSubmissionList.quantity : 1,
            submission_list_item_id: itemToAddInSubmissionList['submission_list_item_id_to_change']
        }
    };

    const url = `/backoffice/companies/${companyId}/submission_lists/convert_submission_list_items/${submissionListId}`;

    fetch(url, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    })
      .then((res) => {
          if (!res.ok)
              throw Error("An error occour during saving data on the database");
          else
              return res.json()
      })
      .then((data) => {
          if (navigateToSubmissionList)
              window.location = `/backoffice/companies/${companyId}/submission_lists/${submissionListId}`;
      })
      .catch((error) => {
          console.error("ERROR:", error);
          dispatch(setShowErrorModal(true));
      });
}


export const convertItem = (conversionItemAlertPopupParams, setConversionItemAlertPopupParams) => (dispatch, getState) => {
    const { environment } = getState();

    let itemToAddInSubmissionList = null
    if (environment === 'backoffice')
        itemToAddInSubmissionList = JSON.parse(window.sessionStorage.getItem(ITEM_TO_ADD_ON_SUBMISSION_LIST_KEY_FOR_SESSION_STORAGE));

    if (itemToAddInSubmissionList) {
        setConversionItemAlertPopupParams(null);
        if (itemToAddInSubmissionList['submission_list_item_id_to_change'])
            dispatch(convertSubmissionListItem(conversionItemAlertPopupParams.blueprintImage, itemToAddInSubmissionList, true))
        else
            dispatch(addBlueprintImagesToSubmissionList([conversionItemAlertPopupParams.blueprintImage], itemToAddInSubmissionList, true))
    }
}


export const clearSessionStorage = () => (dispatch, getState) => {
    window.sessionStorage.removeItem(ITEM_TO_ADD_ON_SUBMISSION_LIST_KEY_FOR_SESSION_STORAGE);
    window.sessionStorage.removeItem(ITEM_TO_GRADE_KEY_FOR_SESSION_STORAGE);
}



export const openGradingModal = (product, label_language, blueprintImage, blueprintImageIndex, railsEnv, defects, previousGrading, setConversionItemAlertPopupParams) => (dispatch, getState) => {
    const { environment } = getState();

    if (blueprintImage?.encasing_id) {
        let itemToAddInSubmissionList = null
        if (environment === 'backoffice')
            itemToAddInSubmissionList = JSON.parse(window.sessionStorage.getItem(ITEM_TO_ADD_ON_SUBMISSION_LIST_KEY_FOR_SESSION_STORAGE));

        // Apro il popup che propone all'utente di aggiungere il prodotto alla submission list
        if (itemToAddInSubmissionList) {
            setConversionItemAlertPopupParams({ showModal: true, submissionListNumber: itemToAddInSubmissionList.submission_list_number, blueprintImage: blueprintImage})

        // Grado il prodotto
        } else {
            const category = blueprintImage.blueprint.category.name;
            const isSingleCard = compareStrings(category, 'singles');

            let url = `/backoffice/statics/translations/get_translations_for_labels.json?language=${convertLanguage(blueprintImage.language)}&blueprint_image_id=${blueprintImage.id}`
            if (isSingleCard) {
                url = url + `&rarity=${blueprintImage.rarity}&version=${blueprintImage.version}&edition=${blueprintImage.edition}`
            } else {
                url = url + `&blueprint_id=${blueprintImage.blueprint_id}&category=${category}&edition=${blueprintImage.edition}`
            }

            fetch(url, {
                method: 'GET'
            })
              .then(response => response.json())
              .then((data) => {
                  // console.log('translations for print on label: ', data)
                  const translations_categories = data.translations_categories
                  const translations_editions = data.translations_editions
                  const translations_rarities = data.translations_rarities
                  const translations_versions = data.translations_versions
                  const translations_qualifiers = data.translations_qualifiers
                  const translations_sealed_informations = data.translations_sealed_informations
                  const translations_graded_by = data.translations_graded_by
                  const translations_artworks = data.translations_artworks

                  blueprintImage = {
                      ...blueprintImage,
                      game_name: data.game_name,
                      game_short_name_1: data.game_short_name_1,
                      en_game_name: data.en_game_name,
                      en_game_short_name_1: data.en_game_short_name_1,
                      encasing_name: data.encasing_name
                  }

                  // Costruisco i due oggetti che contengono i dati da stampare in etichetta raggruppati per lingua
                  // (la lingua originale della blueprintImage e l'inglese, se questi due differiscono)
                  const printingInformationsInNativeLanguage = {
                      category: !isSingleCard && translations_categories && translations_categories[category] && isDefined(translations_categories[category][blueprintImage.language]) ? translations_categories[category][blueprintImage.language] : category,
                      language: blueprintImage.language,
                      name: blueprintImage.meta_name,
                      short_name_1: blueprintImage.short_name_1,
                      expansion: blueprintImage.expansion_name ? blueprintImage.expansion_name : (blueprintImage.en_expansion_name ? blueprintImage.en_expansion_name : ''),
                      expansion_short_name_1: blueprintImage.expansion_short_name_1 ? blueprintImage.expansion_short_name_1 : (blueprintImage.en_expansion_short_name_1 && !IDEOGRAMS_LANGUAGES.includes(blueprintImage.language) ? blueprintImage.en_expansion_short_name_1 : ''),
                      era: blueprintImage.era_name ? blueprintImage.era_name : (blueprintImage.en_era_name ? blueprintImage.en_era_name : ''),
                      era_short_name_1: blueprintImage.era_short_name_1 ? blueprintImage.era_short_name_1 : (blueprintImage.en_era_short_name_1 && !IDEOGRAMS_LANGUAGES.includes(blueprintImage.language) ? blueprintImage.en_era_short_name_1 : ''),
                      game: blueprintImage.game_name ? blueprintImage.game_name : (blueprintImage.en_game_name ? blueprintImage.en_game_name : ''),
                      game_short_name_1: blueprintImage.game_short_name_1 ? blueprintImage.game_short_name_1 : (blueprintImage.en_game_short_name_1 && !IDEOGRAMS_LANGUAGES.includes(blueprintImage.language) ? blueprintImage.en_game_short_name_1 : ''),
                      version: (blueprintImage.version && !compareStrings(blueprintImage.version, 'normal') ?
                        (translations_versions && translations_versions[blueprintImage.version] && isPresent(translations_versions[blueprintImage.version][blueprintImage.language]) ? translations_versions[blueprintImage.version][blueprintImage.language] : parseStaticString2Object(blueprintImage.version)) : parseStaticString2Object('')),
                      rarity: (blueprintImage.rarity && !compareStrings(blueprintImage.rarity, 'no rarity') ?
                        (translations_rarities && translations_rarities[blueprintImage.rarity] && isPresent(translations_rarities[blueprintImage.rarity][blueprintImage.language]) ? translations_rarities[blueprintImage.rarity][blueprintImage.language] : parseStaticString2Object(blueprintImage.rarity)) : parseStaticString2Object('')),
                      edition: (blueprintImage.edition ?
                        (translations_editions && translations_editions[blueprintImage.edition] && isPresent(translations_editions[blueprintImage.edition][blueprintImage.language]) ? translations_editions[blueprintImage.edition][blueprintImage.language] : parseStaticString2Object(blueprintImage.edition)) : parseStaticString2Object('')),
                      artwork: artworkByLocale(translations_artworks, blueprintImage.language) ? artworkByLocale(translations_artworks, blueprintImage.language) : parseStaticString2Object(artworkByLocale(blueprintImage, blueprintImage.language), ''),
                      graded_by: translations_graded_by && isPresent(translations_graded_by[blueprintImage.language]) ? translations_graded_by[blueprintImage.language] : '',
                      qualifiers: translations_qualifiers && isPresent(translations_qualifiers[blueprintImage.language]) ? translations_qualifiers[blueprintImage.language] : {},
                      sealed_informations: translations_sealed_informations && isPresent(translations_sealed_informations[blueprintImage.language]) ? translations_sealed_informations[blueprintImage.language] : {},
                      disabled: !isLanguagePresent(blueprintImage.language) || (label_language && !['native', blueprintImage.language].includes(label_language))
                  };

                  const printingInformationsInEnLanguage = {
                      category: !isSingleCard && translations_categories && translations_categories[category] && isDefined(translations_categories[category]['en']) ? translations_categories[category]['en'] : category,
                      language: 'en',
                      name: blueprintImage.en_name,
                      short_name_1: blueprintImage.en_short_name_1,
                      expansion: blueprintImage.en_expansion_name ? blueprintImage.en_expansion_name : '',
                      expansion_short_name_1: blueprintImage.en_expansion_short_name_1,
                      era: blueprintImage.en_era_name ? blueprintImage.en_era_name : '',
                      era_short_name_1: blueprintImage.en_era_short_name_1,
                      game: blueprintImage.en_game_name ? blueprintImage.en_game_name : '',
                      game_short_name_1: blueprintImage.en_game_short_name_1,
                      version: (blueprintImage.version && !compareStrings(blueprintImage.version, 'normal') ?
                        (translations_versions && translations_versions[blueprintImage.version] && isPresent(translations_versions[blueprintImage.version]['en']) ? translations_versions[blueprintImage.version]['en'] : parseStaticString2Object(blueprintImage.version)) : parseStaticString2Object('')),
                      rarity: (blueprintImage.rarity && !compareStrings(blueprintImage.rarity, 'no rarity') ?
                        (translations_rarities && translations_rarities[blueprintImage.rarity] && isPresent(translations_rarities[blueprintImage.rarity]['en']) ? translations_rarities[blueprintImage.rarity]['en'] : parseStaticString2Object(blueprintImage.rarity)) : parseStaticString2Object('')),
                      edition: (blueprintImage.edition ?
                        (translations_editions && translations_editions[blueprintImage.edition] && isPresent(translations_editions[blueprintImage.edition]['en']) ? translations_editions[blueprintImage.edition]['en'] : parseStaticString2Object(blueprintImage.edition)) : parseStaticString2Object('')),
                      artwork: artworkByLocale(translations_artworks, 'en') ? artworkByLocale(translations_artworks, 'en') : parseStaticString2Object(artworkByLocale(blueprintImage, 'en'), ''),
                      graded_by: translations_graded_by && isPresent(translations_graded_by['en']) ? translations_graded_by['en'] : '',
                      qualifiers: translations_qualifiers && isPresent(translations_qualifiers['en']) ? translations_qualifiers['en'] : {},
                      sealed_informations: translations_sealed_informations && isPresent(translations_sealed_informations['en']) ? translations_sealed_informations['en'] : {},
                      disabled: label_language && label_language !== 'en'
                  };

                  let printingInformationsInAllLanguages = [];
                  
                  if (!printingInformationsInNativeLanguage.disabled) {
                      printingInformationsInAllLanguages.push(printingInformationsInNativeLanguage)
                    }
                    
                    if (!printingInformationsInEnLanguage.disabled &&
                        printingInformationsInNativeLanguage['language'] !== 'en') {
                            printingInformationsInAllLanguages = [printingInformationsInEnLanguage].concat(printingInformationsInAllLanguages)
                    }


                  // Controllo se, tra i dati da stampare in etichetta, ve ne siano alcuni a cui manca la traduzione
                  // per la stampa multilingua, così da poterli segnalare visivamente al gradatore sulla modale di grading
                  let missing_translations = []
                  if (!isSingleCard && (!translations_categories || !translations_categories[category] || !isDefined(translations_categories[category][blueprintImage.language])))
                      missing_translations = [ ...missing_translations, 'category' ]
                  if (!isDefined(blueprintImage.game_name))
                      missing_translations = [ ...missing_translations, 'game' ]
                  if (!isDefined(blueprintImage.era_name))
                      missing_translations = [ ...missing_translations, 'era' ]
                  if (!isDefined(blueprintImage.expansion_name))
                      missing_translations = [ ...missing_translations, 'expansion' ]
                  if (!isDefined(blueprintImage.meta_name))
                      missing_translations = [ ...missing_translations, 'name' ]
                  if (blueprintImage.rarity && !compareStrings(blueprintImage.rarity, 'no rarity') && !isDefined(printingInformationsInNativeLanguage.rarity.meta_name))
                      missing_translations = [ ...missing_translations, 'rarity' ]
                  if (blueprintImage.version && !compareStrings(blueprintImage.version, 'normal') && !isDefined(printingInformationsInNativeLanguage.version.meta_name))
                      missing_translations = [ ...missing_translations, 'version' ]
                  if (blueprintImage && blueprintImage.artworks && Object.keys(blueprintImage.artworks).length > 0 && !isDefined(blueprintImage.artworks[`artwork_${parseLocale(blueprintImage.language)}`]))
                      missing_translations = [ ...missing_translations, 'artwork' ]
                  if (translations_graded_by && !isDefined(translations_graded_by[blueprintImage.language]))
                      missing_translations = [ ...missing_translations, 'graded_by' ]
                  if (translations_sealed_informations && (!isDefined(translations_sealed_informations[blueprintImage.language]) || !isDefined(translations_sealed_informations[blueprintImage.language]['authentic'])))
                      missing_translations = [ ...missing_translations, 'authentic' ]
                  if (translations_sealed_informations && (!isDefined(translations_sealed_informations[blueprintImage.language]) || !isDefined(translations_sealed_informations[blueprintImage.language]['authentic_with_subgrades'])))
                      missing_translations = [ ...missing_translations, 'authentic_with_subgrades' ]
                  printingInformationsInNativeLanguage['missing_translations'] = missing_translations

                  missing_translations = []
                  if (!isSingleCard && (!translations_categories || !translations_categories[category] || !isDefined(translations_categories[category]['en'])))
                      missing_translations = [ ...missing_translations, 'category' ]
                  if (!isDefined(blueprintImage.en_game_name))
                      missing_translations = [ ...missing_translations, 'game' ]
                  if (!isDefined(blueprintImage.en_era_name))
                      missing_translations = [ ...missing_translations, 'era' ]
                  if (!isDefined(blueprintImage.en_expansion_name))
                      missing_translations = [ ...missing_translations, 'expansion' ]
                  if (!isDefined(blueprintImage.en_name))
                      missing_translations = [ ...missing_translations, 'name' ]
                  if (blueprintImage.rarity && !compareStrings(blueprintImage.rarity, 'no rarity') && !isDefined(printingInformationsInEnLanguage.rarity.meta_name))
                      missing_translations = [ ...missing_translations, 'rarity' ]
                  if (blueprintImage.version && !compareStrings(blueprintImage.version, 'normal') && !isDefined(printingInformationsInEnLanguage.version.meta_name))
                      missing_translations = [ ...missing_translations, 'version' ]
                  if (blueprintImage && blueprintImage.artworks && Object.keys(blueprintImage.artworks).length > 0 && !isDefined(blueprintImage.artworks['artwork_eng']))
                      missing_translations = [ ...missing_translations, 'artwork' ]
                  if (translations_graded_by && !isDefined(translations_graded_by['en']))
                      missing_translations = [ ...missing_translations, 'graded_by' ]
                  if (translations_sealed_informations && (!isDefined(translations_sealed_informations['en']) || !isDefined(translations_sealed_informations['en']['authentic'])))
                      missing_translations = [ ...missing_translations, 'authentic' ]
                  if (translations_sealed_informations && (!isDefined(translations_sealed_informations['en']) || !isDefined(translations_sealed_informations['en']['authentic_with_subgrades'])))
                      missing_translations = [ ...missing_translations, 'authentic_with_subgrades' ]
                  printingInformationsInEnLanguage['missing_translations'] = missing_translations


                  // Controllo nel session storage se ci sia un prodotto (supplementary item o mismatched item) che
                  // debba essere gradato nella pagina del grading sul backoffice e, se si, ne importo i parametri di
                  // gradazione scelti dall'utente
                  const blueprintImageToGrade = { ...blueprintImage }
                  if (environment === 'backoffice') {
                      const itemToGrade = JSON.parse(window.sessionStorage.getItem(ITEM_TO_GRADE_KEY_FOR_SESSION_STORAGE));
                      dispatch(clearSessionStorage());

                      if (itemToGrade?.supplementary_item_id)
                          blueprintImageToGrade["supplementary_item_id"] = itemToGrade.supplementary_item_id;

                      if (itemToGrade?.description)
                          blueprintImageToGrade["description"] = itemToGrade.description;

                      if (itemToGrade?.mismatched_item_id)
                          blueprintImageToGrade["mismatched_item_id"] = itemToGrade.mismatched_item_id;

                      if (itemToGrade?.requested_service)
                          blueprintImageToGrade["requested_service"] = itemToGrade.requested_service;

                      if (itemToGrade?.encasing)
                          blueprintImageToGrade["encasing"] = itemToGrade.encasing;

                      if (itemToGrade?.grading_lower_limit)
                          blueprintImageToGrade["grading_lower_limit"] = itemToGrade.grading_lower_limit;

                      if (itemToGrade?.case_lower_limit)
                          blueprintImageToGrade["case_lower_limit"] = itemToGrade.case_lower_limit;

                      if (itemToGrade?.user_id)
                          blueprintImageToGrade["owner"] = itemToGrade.user_id;

                      if (itemToGrade?.submission_list_id && itemToGrade?.user_id)
                          blueprintImageToGrade["submission_list_id"] = itemToGrade.submission_list_id + '_' + itemToGrade.user_id;

                      if (itemToGrade?.submission_list_number && itemToGrade?.user_id)
                          blueprintImageToGrade["submission_list_number"] = itemToGrade.submission_list_number + '_' + itemToGrade.user_id;

                      if (itemToGrade?.label_language) {
                        if (itemToGrade.label_language === 'native') 
                            itemToGrade['label_language'] = convertLanguage(blueprintImageToGrade.language);
                        else
                            itemToGrade['label_language'] = convertLanguage(itemToGrade['label_language']);
                      }

                      if (itemToGrade?.label_type)
                          blueprintImageToGrade["label_type"] = itemToGrade.label_type;

                      if (itemToGrade?.backoffice_note)
                          blueprintImageToGrade["backoffice_note"] = itemToGrade.backoffice_note;

                      if (itemToGrade?.label_language && printingInformationsInAllLanguages.length > 1)
                          printingInformationsInAllLanguages = printingInformationsInAllLanguages.filter((printingInformations) => printingInformations.language == itemToGrade.label_language);     
                    }

                  dispatch({type: 'OPEN_GRADING_MODAL',
                      payload: { product: product,
                          blueprintImage: blueprintImageToGrade,
                          blueprintImageIndex: blueprintImageIndex,
                          printingInformationsInAllLanguages: printingInformationsInAllLanguages,
                          railsEnv: railsEnv,
                          defects: defects,
                          previousGrading: previousGrading
                      }
                  })

                  $('#printLabelModal').modal()
              })
              .catch((error) => {
                  console.error("ERROR:", error);
                  dispatch(setShowErrorModal(true));
              });
        }
    }

}


export const setNewGradeOverall = (finalGrading) => (dispatch, getState) => {
    // console.log('finalGrading: ', finalGrading)
    const { blueprintImages, submission_list } = getState();

    let newBlueprintImages = blueprintImages.map((blueprintImage) => {
        if (blueprintImage.product_id === finalGrading.productId && !blueprintImage.rejected &&
          blueprintImage.state !== 'graded' && !isInAClosingState(submission_list)) {
            let newBlueprintImage = { ...blueprintImage }
            newBlueprintImage['state'] = 'graded';
            newBlueprintImage['encasing'] = finalGrading.grading.encasing;
            newBlueprintImage['requested_service'] = finalGrading.requested_service;
            newBlueprintImage['label_type'] = finalGrading.label_type;
            newBlueprintImage['backoffice_note'] = finalGrading.backoffice_note;
            newBlueprintImage['flaws'] = finalGrading.flaws;
            newBlueprintImage['state'] = 'graded';
            for (const key of ['current_grading', 'grading']) {
                newBlueprintImage[key] = {
                    ...finalGrading.grading,
                    serial_number: finalGrading.serialNumber,
                    graded_image_file_name: finalGrading.graded_image_file_name,
                    graded_back_image_file_name: finalGrading.graded_back_image_file_name,
                    thumb_graded_image_url: finalGrading.thumb_graded_image_url,
                    thumb_graded_back_image_url: finalGrading.thumb_graded_back_image_url,
                    xx_large_graded_image_url: finalGrading.xx_large_graded_image_url,
                    xx_large_graded_back_image_url: finalGrading.xx_large_graded_back_image_url
                };
            }
            return newBlueprintImage
        }

        // console.log('blueprintImage: ', blueprintImage)
        return blueprintImage
    })

    if (finalGrading.submissionListState) {
        let newSubmissionList = { ...submission_list };
        newSubmissionList["state"] = finalGrading.submissionListState;
        dispatch(setSubmissionList(newSubmissionList));
    }
    dispatch(setBlueprintImages(newBlueprintImages));
}

export const rejectProduct = (blueprintImage, rejectingCause) => (dispatch, getState) => {
    const { blueprintImages, submission_list, companyId } = getState();

    if (!isInAClosingState(submission_list) && !blueprintImage.rejected &&
      (!blueprintImage.grading || (blueprintImage.state === 'regrading' && blueprintImage.current_submission_list_id === submission_list.id))) {
        const url = `/backoffice/companies/${companyId}/submission_list_items/${blueprintImage.submission_list_item_id}`;

        fetch(url + ".json", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ rejected: rejectingCause, grading_id: null }),
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then((data) => {
              let newBlueprintImages = blueprintImages.map((bi) => {
                  if (bi.submission_list_item_id === blueprintImage.submission_list_item_id)
                    return { ...data.submission_list_items[0] }
                  return bi
              })

              let newSubmissionList = {
                ...submission_list,
                state: data.submission_list_state,
                can_be_reopened: data.can_be_reopened,
                grading_certificates_images_importable: data.submission_list_grading_certificates_images_importable
              }
              dispatch(setSubmissionList(newSubmissionList))
              dispatch(setBlueprintImages(newBlueprintImages))
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}

export const rejectSupplementaryItem = (supplementaryItem, rejectingCause) => (dispatch, getState) => {
    const { submission_list, companyId } = getState();

    if (!isInAClosingState(submission_list) && !supplementaryItem.rejected) {
        const url = `/backoffice/companies/${companyId}/supplementary_items/${supplementaryItem.id}`;

        fetch(url + ".json", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ rejected: rejectingCause }),
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then((data) => {
              let newSupplementaryItems = submission_list.supplementary_items.map((si) => {
                  if (si.id === supplementaryItem.id)
                      return { ...si, rejected: rejectingCause }
                  return si
              })

              dispatch(setSubmissionList({ ...data, supplementary_items: newSupplementaryItems }))
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}

export const changeGradedImage = (e, submissionListItemId, side) => (dispatch, getState) => {
    let file = e.target.files[0];
    if (!file && e.dataTransfer)
        file = e.dataTransfer.files[0];

    if (file) {
        const { blueprintImages, submission_list, companyId } = getState();

        const formData = new FormData();
        formData.append(side, file);

        const url = `/backoffice/companies/${companyId}/submission_list_items/${submissionListItemId}`;
        fetch(url + '.json', {
            method: 'PUT',
            body: formData
        }).then(response => {
            if (!response.ok) {
                throw Error("An error occour during saving data on the database");
            } else {
                return response.json();
            }
        }).then(data => {
            let newBlueprintImages = blueprintImages.map((blueprintImage) => {
                if (blueprintImage.submission_list_item_id === submissionListItemId && !blueprintImage.rejected && blueprintImage.grading) {
                    let newBlueprintImage = { ...blueprintImage }
                    const item = data.submission_list_items[0]
                    if (side === 'graded_image') {
                        newBlueprintImage["grading"] = { ...blueprintImage.grading}
                        newBlueprintImage["grading"]["graded_image_file_name"] = item.grading.graded_image_file_name;
                        newBlueprintImage["grading"]["thumb_graded_image_url"] = item.grading.thumb_graded_image_url;
                        newBlueprintImage["grading"]["xx_large_graded_image_url"] = item.grading.xx_large_graded_image_url;
                        newBlueprintImage["grading"]["is_valid"] = item.grading.is_valid;
                    }
                    else if (side === 'graded_back_image') {
                        newBlueprintImage["grading"] = { ...blueprintImage.grading}
                        newBlueprintImage["grading"]["graded_back_image_file_name"] = item.grading.graded_back_image_file_name;
                        newBlueprintImage["grading"]["thumb_graded_back_image_url"] = item.grading.thumb_graded_back_image_url;
                        newBlueprintImage["grading"]["xx_large_graded_back_image_url"] = item.grading.xx_large_graded_back_image_url;
                        newBlueprintImage["grading"]["is_valid"] = item.grading.is_valid;
                    }
                    return newBlueprintImage
                }
                return blueprintImage
            })

            let newSubmissionList = { ...submission_list }
            newSubmissionList['state'] = data.submission_list_state
            dispatch(setSubmissionList(newSubmissionList))
            dispatch(setBlueprintImages(newBlueprintImages))
        })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}

export const getSubGrades = (serialNumber, category, setShowGradingDetails) => (dispatch, getState) => {
    if (serialNumber) {
        const url = `/backoffice/serial_numbers/get_grading_by_serial_number/${serialNumber}`;

        fetch(url + '.json')
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during getting data from database");
              else
                  return res.json()
          })
          .then(grading => {
              setShowGradingDetails({ ...grading, category: category });
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}

export const rejectAllProducts = (rejectingCause) => (dispatch, getState) => {
    const { submission_list, blueprintImages, submission_list_items_ids, supplementary_items_ids, companyId } = getState()

    if (submission_list.items_count > 0 && !isInAClosingState(submission_list)) {
        const url = `/backoffice/companies/${companyId}/submission_lists/reject_all_items/${submission_list.id}`;

        fetch(url + ".json", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                rejected: rejectingCause,
                submission_list_items_ids: submission_list_items_ids,
                supplementary_items_ids: supplementary_items_ids
            }),
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then((data) => {
              let newBlueprintImages = blueprintImages.map((blueprintImage) => {
                  if (!blueprintImage.rejected && (!blueprintImage.grading ||
                    (blueprintImage.state === 'regrading' && blueprintImage.current_submission_list_id === submission_list.id))) {
                      let newBlueprintImage = { ...blueprintImage }
                      newBlueprintImage['rejected'] = rejectingCause
                      return newBlueprintImage
                  }
                  return blueprintImage
              })

              let newSupplementaryItems = submission_list.supplementary_items.map((si) => {
                  if (!si.rejected)
                      return { ...si, rejected: rejectingCause }
                  return si
              })

              let newSubmissionList = {
                  ...submission_list,
                  supplementary_items: newSupplementaryItems,
                  state: data.state,
                  can_be_reopened: data.can_be_reopened,
                  grading_certificates_images_importable: data.grading_certificates_images_importable
              }
              dispatch(setSubmissionList(newSubmissionList))
              dispatch(setBlueprintImages(newBlueprintImages))
              dispatch(setShowSuccessFlashMessage(true))
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}

export const enableAllProductsRegrading = () => (dispatch, getState) => {
    const { blueprintImages, submission_list, submission_list_items_ids, companyId } = getState();

    if (!isInAClosingState(submission_list) && submission_list.items_count > 0) {
        const url = `/backoffice/companies/${companyId}/submission_lists/update_all_products/${submission_list.id}`;

        fetch(url + '.json', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ state: 'regrading', submission_list_items_ids: submission_list_items_ids }),
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then(data => {
              let newBlueprintImages = blueprintImages.map((bi) => {
                  if (!bi.rejected && bi.grading && bi.state !== 'regrading' && bi.current_submission_list_id === submission_list.id) {
                      let newBlueprintImage = { ...bi }
                      newBlueprintImage['state'] = 'regrading';
                      newBlueprintImage["grading"] = { ...bi.grading}
                      newBlueprintImage["grading"]["graded_image_file_name"] = null;
                      newBlueprintImage["grading"]["graded_back_image_file_name"] = null;
                      newBlueprintImage["grading"]["thumb_graded_image_url"] = null;
                      newBlueprintImage["grading"]["thumb_graded_back_image_url"] = null;
                      newBlueprintImage["grading"]["xx_large_graded_image_url"] = null;
                      newBlueprintImage["grading"]["xx_large_graded_back_image_url"] = null;
                      return newBlueprintImage
                  }
                  return bi
              })

              dispatch(setSubmissionList({ ...data, supplementary_items: submission_list.supplementary_items }))
              dispatch(setBlueprintImages(newBlueprintImages));
              dispatch(setShowSuccessFlashMessage(true))
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}

export const cancelAllProductsRejections = () => (dispatch, getState) => {
    const { blueprintImages, submission_list, submission_list_items_ids, supplementary_items_ids, companyId } = getState();

    if (!isInAClosingState(submission_list) && submission_list.items_count > 0) {
        const url = `/backoffice/companies/${companyId}/submission_lists/update_all_items/${submission_list.id}`;

        fetch(url + '.json', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                cancel_rejection: true,
                submission_list_items_ids: submission_list_items_ids,
                supplementary_items_ids: supplementary_items_ids
            }),
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then(data => {
              let newBlueprintImages = blueprintImages.map((bi) => {
                  if (bi.rejected && bi.current_submission_list_id === submission_list.id) {
                      return { ...(data.submission_list_items.find(item => item.submission_list_item_id == bi.submission_list_item_id)) };
                  }
                  return bi
              })

              let newSupplementaryItems = submission_list.supplementary_items.map((si) => {
                  if (si.rejected)
                      return { ...si, rejected: null }
                  return si
              })

              let newSubmissionList = { ...submission_list, supplementary_items: newSupplementaryItems, grading_certificates_images_importable: data.submission_list_grading_certificates_images_importable }
              newSubmissionList['state'] = data.submission_list_state
              dispatch(setSubmissionList(newSubmissionList))
              dispatch(setBlueprintImages(newBlueprintImages));
              dispatch(setShowSuccessFlashMessage(true))
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}


export const enableProductRegrading = (blueprintImage) => (dispatch, getState) => {
    const { blueprintImages, submission_list } = getState();
    if (!blueprintImage.rejected && blueprintImage.state !== 'regrading' && blueprintImage.grading &&
      blueprintImage.current_submission_list_id === submission_list.id && !isInAClosingState(submission_list)) {
        const url = `/backoffice/products/change_product_state/${blueprintImage.submission_list_item_id}`;

        fetch(url + ".json", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ product: { state: 'regrading' } }),
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then((data) => {
              let newBlueprintImages = blueprintImages.map((bi) => {
                  if (bi.product_id === blueprintImage.product_id) {
                      let newBlueprintImage = { ...bi }
                      newBlueprintImage['state'] = 'regrading';
                      newBlueprintImage["grading"] = { ...blueprintImage.grading}
                      newBlueprintImage["grading"]["graded_image_file_name"] = null;
                      newBlueprintImage["grading"]["graded_back_image_file_name"] = null;
                      newBlueprintImage["grading"]["thumb_graded_image_url"] = null;
                      newBlueprintImage["grading"]["thumb_graded_back_image_url"] = null;
                      newBlueprintImage["grading"]["xx_large_graded_image_url"] = null;
                      newBlueprintImage["grading"]["xx_large_graded_back_image_url"] = null;
                      return newBlueprintImage
                  }
                  return bi
              })

              let newSubmissionList = { ...submission_list, grading_certificates_images_importable: data.submission_list_grading_certificates_images_importable}
              newSubmissionList['state'] = data.submission_list.state
              dispatch(setSubmissionList(newSubmissionList))
              dispatch(setBlueprintImages(newBlueprintImages));
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}

export const saveFlaws = (blueprintImage, flaws, onSuccessCallBack) => (dispatch, getState) => {
    const { blueprintImages, submission_list, companyId } = getState();
    const submissionListItemId = blueprintImage.submission_list_item_id;

    if (blueprintImage?.submission_list_item_id && flaws?.length > 0) {
        const url = `/backoffice/companies/${companyId}/submission_list_items/${submissionListItemId}`;

        console
        fetch(url + '.json', {
            method: 'PUT',
            body: createFormData({ submission_list_item: { flaws: flaws } }),
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then(data => {
              let newBlueprintImages = blueprintImages.map((bi) => {
                  if (bi.submission_list_item_id === submissionListItemId)
                      return { ...data.submission_list_items[0] }
                  return bi
              })

              dispatch(setBlueprintImages(newBlueprintImages));
              if (onSuccessCallBack)
                onSuccessCallBack();

              // newSubmissionList['state'] = data.submission_list_state
              // dispatch(setSubmissionList(newSubmissionList))
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}


export const cancelProductRejection = (blueprintImage) => (dispatch, getState) => {
    const { blueprintImages, submission_list, companyId } = getState();
    if (blueprintImage.rejected &&
      blueprintImage.current_submission_list_id === submission_list.id && !isInAClosingState(submission_list)) {
        const url = `/backoffice/companies/${companyId}/submission_list_items/${blueprintImage.submission_list_item_id}`;

        fetch(url + '.json', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ cancel_rejection: true }),
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then(data => {
              let newBlueprintImages = blueprintImages.map((bi) => {
                  if (bi.submission_list_item_id === blueprintImage.submission_list_item_id)
                    return { ...data.submission_list_items[0] }
                  return bi
              })

              dispatch(setBlueprintImages(newBlueprintImages));
              let newSubmissionList = { ...submission_list, grading_certificates_images_importable: data.submission_list_grading_certificates_images_importable }
              newSubmissionList['state'] = data.submission_list_state
              dispatch(setSubmissionList(newSubmissionList))
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}


export const cancelSupplementaryItemRejection = (supplementaryItem) => (dispatch, getState) => {
    const { submission_list, companyId } = getState();

    if (supplementaryItem.rejected && !isInAClosingState(submission_list)) {
        const url = `/backoffice/companies/${companyId}/supplementary_items/${supplementaryItem.id}`;

        fetch(url + '.json', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ cancel_rejection: true }),
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then(data => {
              let newSupplementaryItems = submission_list.supplementary_items.map((si) => {
                  if (si.id === supplementaryItem.id)
                      return { ...si, rejected: null }
                  return si
              })

              dispatch(setSubmissionList({ ...data, supplementary_items: newSupplementaryItems }))
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}


export const deleteSubmissionListItem = (blueprintImage) => (dispatch, getState) => {
    const { blueprintImages, submission_list, companyId } = getState();

    const submissionListItemId = blueprintImage.submission_list_item_id

    if (!isInAClosingState(submission_list) && (['middleman', 'grader'].includes(blueprintImage.created_by) || submission_list.current_company_user_owner)) {
        const url = `/backoffice/companies/${companyId}/submission_list_items/${blueprintImage.submission_list_item_id}`;

        fetch(url + ".json", {
            method: "DELETE",
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then((data) => {
              let newBlueprintImages = blueprintImages.filter((bi) => bi.submission_list_item_id !== blueprintImage.submission_list_item_id )
              dispatch(setBlueprintImages(newBlueprintImages));

              let newSubmissionList = { ...submission_list, grading_certificates_images_importable: data.submission_list_grading_certificates_images_importable }

              if (submission_list.supplementary_items) {
                  newSubmissionList['supplementary_items'] = submission_list.supplementary_items.map((item) => {
                      if (item.submission_list_item_id === submissionListItemId)
                          return { ...item, submission_list_item_id: null }
                      return item
                  })
              }

              dispatch(setSubmissionList({ ...data, supplementary_items: submission_list.supplementary_items }))
              dispatch(setBlueprintImages(newBlueprintImages));
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}


export const deleteSupplementaryItem = (supplementaryItem) => (dispatch, getState) => {
    const { submission_list, companyId } = getState();

    if (!isInAClosingState(submission_list) &&
      (['middleman', 'grader'].includes(supplementaryItem.created_by) || submission_list.current_company_user_owner)) {
        const url = `/backoffice/companies/${companyId}/supplementary_items/${supplementaryItem.id}`;

        fetch(url + ".json", {
            method: "DELETE",
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then((data) => {
              let newSupplementaryItems = submission_list.supplementary_items.filter((si) => si.id !== supplementaryItem.id )
              dispatch(setSubmissionList({ ...data, supplementary_items: newSupplementaryItems }));
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}


export const cancelGrading = (blueprintImage) => (dispatch, getState) => {
    const { blueprintImages, submission_list, companyId } = getState();

    if (isInAClosingState(submission_list) && blueprintImage.grading.is_valid) {
        const url = `/backoffice/companies/${companyId}/gradings/cancel_grading/${blueprintImage.grading.id}`;

        fetch(url + ".json", {
            method: "PUT",
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then((data) => {
              let newBlueprintImages = blueprintImages.map((bi) => {
                  if (bi.submission_list_item_id === blueprintImage.submission_list_item_id)
                      return { ...bi, grading: { ...bi.grading, is_valid: false} }
                  return bi
              })

              dispatch(setBlueprintImages(newBlueprintImages));
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}


export const updateSubmissionList = (body) => (dispatch, getState) => {
    const { submission_list, companyId } = getState();

    if (((['confirmed', 'received', 'closed'].includes(body.state) || body.deferred_payment_carried_out) && window.confirm("Are you sure?")) ||
      body.courier_id || body.new_courier ||
      (body && ('note' in body || 'backoffice_note' in body || ('title' in body && submission_list.created_by === 'grader'))) ||
      (body['reopen'] === true && window.confirm("Are you sure?"))) {
        const url = `/backoffice/companies/${companyId}/submission_lists/${submission_list.id}`;

        if (body.courier_id || body.new_courier)
            body['state'] = 'closed'

        fetch(url + ".json", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ submission_list: body }),
        })
          .then((response) => {
              if (!response.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return response.json();
          })
          .then((data) => {
              dispatch(setSubmissionList({ ...data, supplementary_items: submission_list.supplementary_items }))
              dispatch(setShowSuccessFlashMessage(true))
              // if(data.state === 'received'){
              //   printReceivedSubmissionLabel(data);
              // }
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}


export const generateRandomGradings = () => (dispatch, getState) => {
    const { submission_list, submission_list_items_ids, companyId } = getState();

    if (!isInAClosingState(submission_list)) {
        const url = `/backoffice/companies/${companyId}/submission_lists/random_grading/${submission_list.id}`;

        dispatch(setShowFullScreenLoadingOverlay(true))

        fetch(url + ".json", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ submission_list_items_ids: submission_list_items_ids }),
        })
          .then((response) => {
              dispatch(setShowFullScreenLoadingOverlay(false))
              if (!response.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return response.json();
          })
          .then((data) => {
              window.location.reload()
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}


export const enableChangeSubmissionListGlobalAmountOrRevenue = (newSubmissionListAmountOrRevenue, setNewSubmissionListAmountOrRevenue, showAmountModal, setShowAmountModal, showRevenueModal, setShowRevenueModal) => (dispatch, getState) => {
    const { submission_list, companyId } = getState();

    if (isPresent(newSubmissionListAmountOrRevenue)) {
        let url = `/backoffice/companies/${companyId}/submission_lists`

        const body = {}
        if (showAmountModal) {
            url = url + `/set_amount/${submission_list.id}`;
            body[showAmountModal] = newSubmissionListAmountOrRevenue;
        }
        else {
            url = url + `/set_revenue/${submission_list.id}`;
            body["revenue"] = newSubmissionListAmountOrRevenue;
        }

        fetch(url + '.json', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(['home_pick_up_cost', 'shipping_cost', 'insurance_cost', 'user_credit'].includes(showAmountModal) ? { submission_list: body } : body),
        })
          .then((res) => {
              setShowAmountModal(null)
              setShowRevenueModal(false)
              setNewSubmissionListAmountOrRevenue(null)
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then(data => {
              dispatch(setSubmissionList({ ...data, supplementary_items: submission_list.supplementary_items }))
              dispatch(setShowSuccessFlashMessage(true))
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}


export const enableChangeItemAmount = (newAmount, amountType) => (dispatch, getState) => {
    const { blueprintImages, submission_list, submission_list_items_ids, supplementary_items_ids, companyId } = getState();

    if (newAmount && newAmount.id) {
        let url = ''
        let body = {}
        if (newAmount.id !== 'all') {
            body[amountType] = newAmount[amountType]
            url = `/backoffice/companies/${companyId}/${newAmount.entity}s/set_amount/${newAmount.id}`;
        }
        else {
            body = { submission_list_items_ids: submission_list_items_ids, supplementary_items_ids: supplementary_items_ids }
            body[`items_${amountType}`] = newAmount[amountType]
            url = `/backoffice/companies/${companyId}/submission_lists/set_amount/${submission_list.id}`;
        }

        fetch(url + '.json', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then(data => {
              let newBlueprintImages = blueprintImages.map((bi) => {
                  if (newAmount.id !== 'all') {
                      if (bi.submission_list_item_id === newAmount.id) {
                          let newBlueprintImage = { ...bi }
                          newBlueprintImage[amountType] = newAmount[amountType];
                          newBlueprintImage[`saved_${amountType}`] = true
                          return newBlueprintImage
                      } else {
                          let newBlueprintImage = { ...bi }
                          newBlueprintImage[`saved_${amountType}`] = null
                          return newBlueprintImage
                      }
                  } else {
                      let newBlueprintImage = { ...bi }
                      newBlueprintImage[amountType] = newAmount[amountType];
                      return newBlueprintImage
                  }
              })

              let newSupplementaryitems = submission_list.supplementary_items.map((si) => {
                  if (newAmount.id !== 'all') {
                      if (si.id === newAmount.id) {
                          let newSupplementaryItem = { ...si }
                          newSupplementaryItem[amountType] = newAmount[amountType];
                          newSupplementaryItem[`saved_${amountType}`] = true
                          return newSupplementaryItem
                      } else {
                          let newSupplementaryItem = { ...si }
                          newSupplementaryItem[`saved_${amountType}`] = null
                          return newSupplementaryItem
                      }
                  } else {
                      let newSupplementaryItem = { ...si }
                      newSupplementaryItem[amountType] = newAmount[amountType];
                      return newSupplementaryItem
                  }
              })

              dispatch(setBlueprintImages(newBlueprintImages));
              dispatch(setSubmissionList({ ...data, supplementary_items: newSupplementaryitems }))
              dispatch(setShowSuccessFlashMessage(true))
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}


export const enableChangeItemRevenue = (newRevenue) => (dispatch, getState) => {
    const { blueprintImages, submission_list, submission_list_items_ids, supplementary_items_ids, companyId } = getState();

    if (newRevenue && newRevenue.id) {
        let url = ''
        let body = {}
        if (newRevenue.id !== 'all') {
            body = { revenue: newRevenue.revenue }
            url = `/backoffice/companies/${companyId}/${newRevenue.entity}s/set_revenue/${newRevenue.id}`;
        }
        else {
            body = { items_revenue: newRevenue.revenue, submission_list_items_ids: submission_list_items_ids, supplementary_items_ids: supplementary_items_ids }
            url = `/backoffice/companies/${companyId}/submission_lists/set_revenue/${submission_list.id}`;
        }

        fetch(url + '.json', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then(data => {
              let newBlueprintImages = blueprintImages.map((bi) => {
                  if (newRevenue.id !== 'all') {
                      if (bi.submission_list_item_id === newRevenue.id) {
                          let newBlueprintImage = { ...bi }
                          newBlueprintImage['revenue'] = newRevenue.revenue;
                          newBlueprintImage['saved_revenue'] = true
                          return newBlueprintImage
                      } else {
                          let newBlueprintImage = { ...bi }
                          newBlueprintImage['saved_revenue'] = null
                          return newBlueprintImage
                      }
                  } else {
                      let newBlueprintImage = { ...bi }
                      newBlueprintImage['revenue'] = newRevenue.revenue;
                      return newBlueprintImage
                  }
              })

              let newSupplementaryitems = submission_list.supplementary_items.map((si) => {
                  if (newRevenue.id !== 'all') {
                      if (si.id === newRevenue.id) {
                          let newSupplementaryItem = { ...si }
                          newSupplementaryItem['revenue'] = newRevenue.revenue;
                          newSupplementaryItem['saved_revenue'] = true
                          return newSupplementaryItem
                      } else {
                          let newSupplementaryItem = { ...si }
                          newSupplementaryItem['saved_revenue'] = null
                          return newSupplementaryItem
                      }
                  } else {
                      let newSupplementaryItem = { ...si }
                      newSupplementaryItem['revenue'] = newRevenue.revenue;
                      return newSupplementaryItem
                  }
              })

              dispatch(setBlueprintImages(newBlueprintImages));
              dispatch(setSubmissionList({ ...data, supplementary_items: newSupplementaryitems }))
              dispatch(setShowSuccessFlashMessage(true))
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}


export const changeGradingsVisibilityForCustomer = () => (dispatch, getState) => {
    const { submission_list, companyId } = getState();

    if (window.confirm("Are you sure?")) {
        let url = `/backoffice/companies/${companyId}/submission_lists/${submission_list.id}`;

        const visibility = !submission_list.show_gradings

        fetch(url + '.json', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ submission_list: { show_gradings: visibility }}),
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then(data => {
              let newSubmissionList = { ...submission_list };
              newSubmissionList["show_gradings"] = visibility;
              dispatch(setSubmissionList(newSubmissionList));
              dispatch(setShowSuccessFlashMessage(true))
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}


export const enableApplyVoucher = (voucher, setVoucher) => (dispatch, getState) => {
    const { submission_list, companyId } = getState();

    if (!submission_list.voucher && window.confirm("Are you sure?")) {
        let url = `/backoffice/companies/${companyId}/submission_lists/apply_voucher/${submission_list.id}`;

        fetch(url + '.json', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ voucher_code: voucher?.code }),
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then(data => {
              setVoucher({ ...voucher, code: null, is_valid: data.backoffice_voucher?.is_valid });

              const newSubmissionList = data
              newSubmissionList['supplementary_items'] = submission_list.supplementary_items

              if (data.backoffice_voucher?.is_valid)
                  dispatch(setShowSuccessFlashMessage(true))
              else
                newSubmissionList['backoffice_voucher'] = null

              dispatch(setSubmissionList(newSubmissionList));
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}

export const disableItemsUpdateOptions = (id, entityType) => (dispatch, getState) => {
    const { blueprintImages, submission_list } = getState();

    if (!isInAClosingState(submission_list)) {
        if (entityType === 'submission_list_item' || id === 'all') {
            let newBlueprintImages = blueprintImages.map((blueprintImage) => {
                if (['all', blueprintImage.product_id].includes(id)) {
                    let newBlueprintImage = { ...blueprintImage }
                    newBlueprintImage['enable_change_encasing'] = false;
                    newBlueprintImage['enable_change_requested_service'] = false;
                    newBlueprintImage['enable_change_label_language'] = false;
                    return newBlueprintImage
                }
                return blueprintImage
            })

            dispatch(setBlueprintImages(newBlueprintImages));

        }

        if (entityType === 'supplementary_item' || id === 'all') {
            let newSupplementaryItems = submission_list.supplementary_items.map((supplementaryItem) => {
                if (['all', supplementaryItem.id].includes(id)) {
                    let newSupplementaryItem = { ...supplementaryItem }
                    newSupplementaryItem['enable_change_encasing'] = false;
                    newSupplementaryItem['enable_change_requested_service'] = false;
                    newSupplementaryItem['enable_change_label_language'] = false;
                    return newSupplementaryItem
                }
                return supplementaryItem
            })

            dispatch(setSubmissionList({ ...submission_list, supplementary_items: newSupplementaryItems }));
        }
    }
}


export const enableChangeProductParam = (productId, key) => (dispatch, getState) => {
    const { blueprintImages, submission_list } = getState();

    let newBlueprintImages = blueprintImages.map((blueprintImage) => {
        if (blueprintImage.product_id === productId && blueprintImage.state !== 'graded' &&
          [null, 'mismatched'].includes(blueprintImage.rejected) && blueprintImage.current_submission_list_id === submission_list.id &&
          !isInAClosingState(submission_list)) {
            let newBlueprintImage = { ...blueprintImage }
            newBlueprintImage[`enable_change_${key}`] = true;
            return newBlueprintImage
        }
        return blueprintImage
    })

    dispatch(setBlueprintImages(newBlueprintImages));
}


export const enableChangeSupplementaryItemParam = (supplementaryItemId, key) => (dispatch, getState) => {
    const { submission_list } = getState();

    let newSupplementaryItems = submission_list.supplementary_items.map((supplementaryItem) => {
        if (supplementaryItem.id === supplementaryItemId && [null, 'mismatched'].includes(supplementaryItem.rejected) &&
          !isInAClosingState(submission_list)) {
            let newSupplementaryItem = { ...supplementaryItem }
            newSupplementaryItem[`enable_change_${key}`] = true;
            return newSupplementaryItem
        }
        return supplementaryItem
    })

    dispatch(setSubmissionList({ ...submission_list, supplementary_items: newSupplementaryItems }));
}

export const changeProductParam = (blueprintImage, key, value) => (dispatch, getState) => {
    const { blueprintImages, submission_list, companyId } = getState();
    if (blueprintImage.state !== 'graded' && [null, 'mismatched'].includes(blueprintImage.rejected) &&
      blueprintImage.current_submission_list_id === submission_list.id &&
      !isInAClosingState(submission_list) && blueprintImage[key] !== value) {
        const url = `/backoffice/companies/${companyId}/submission_list_items/${blueprintImage.submission_list_item_id}`;

        const body = {};
        body[key] = value;

        fetch(url + ".json", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ submission_list_item: body }),
        })
          .then((res) => {
            if (!res.ok)
              throw Error("An error occour during saving data on the database");
            else return res.json();
          })
          .then((data) => {
            let newBlueprintImages = blueprintImages.map((bi) => {
              if (
                bi.submission_list_item_id ===
                blueprintImage.submission_list_item_id
              )
                return { ...data.submission_list_items[0] };
              return bi;
            });

            dispatch(
              setSubmissionList({
                ...submission_list,
                base_revenue: data.submission_list_base_revenue,
                extra_revenue: data.submission_list_extra_revenue,
                revenue: data.submission_list_revenue,
              })
            );
            dispatch(setBlueprintImages(newBlueprintImages));
          })
          .catch((error) => {
            console.error("ERROR:", error);
            dispatch(setShowErrorModal(true));
          });
    }
}

export const saveItemNote = (item, key) => (dispatch, getState) => {
    const { blueprintImages, submission_list, companyId } = getState();
    const url = `/backoffice/companies/${companyId}/${item.entity}s/${item.entity === 'submission_list_item' ? item.submission_list_item_id : item.id}`;

    const body = {};
    body[key] = item[key];

    fetch(url + '.json', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    })
      .then((res) => {
          if (!res.ok)
              throw Error("An error occour during saving data on the database");
          else
              return res.json()
      })
      .then(data => {
          if (item.entity === 'submission_list_item') {
              let newBlueprintImages = blueprintImages.map((bi) => {
                  if (bi.submission_list_item_id === item.submission_list_item_id) {
                      let newBi = { ...bi };
                      newBi[key] = item[key];
                      return newBi;
                  }
                  return bi;
              });

              dispatch(setBlueprintImages(newBlueprintImages));
          }
          else {
              let newSupplementaryItems = submission_list.supplementary_items.map((si) => {
                  if (si.id === item.id) {
                      let newSupplementaryItem = { ...si }
                      newSupplementaryItem[key] = item[key];
                      return newSupplementaryItem
                  }
                  return si
              })

              dispatch(setSubmissionList({ ...data, supplementary_items: newSupplementaryItems }));
          }
      })
      .catch((error) => {
          console.error("ERROR:", error);
          dispatch(setShowErrorModal(true));
      });
}

export const changeSupplementaryItemParam = (supplementaryItem, key, value) => (dispatch, getState) => {
    const { submission_list, companyId } = getState();

    if ([null, 'mismatched'].includes(supplementaryItem.rejected) &&
      !isInAClosingState(submission_list) && supplementaryItem[key] !== value) {
        const url = `/backoffice/companies/${companyId}/supplementary_items/${supplementaryItem.id}`;

        const body = {};
        body[key] = value;

        fetch(url + '.json', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then(data => {
              let newSupplementaryItems = submission_list.supplementary_items.map((si) => {
                  if (si.id === supplementaryItem.id) {
                      let newSupplementaryItem = { ...si }
                      newSupplementaryItem[key] = value;
                      newSupplementaryItem[`enable_change_${key === 'label_type' ? 'encasing' : key}`] = false;
                      return newSupplementaryItem
                  }
                  return si
              })

              dispatch(setSubmissionList({ ...data, supplementary_items: newSupplementaryItems }));
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}

export const changeParamForAllItems = (key, value) => (dispatch, getState) => {
    const { submission_list, submission_list_items_ids, supplementary_items_ids, companyId } = getState();

    if (isDefined(value) && submission_list.items_count > 0 && !isInAClosingState(submission_list)) {
        const url = `/backoffice/companies/${companyId}/submission_lists/update_all_items/${submission_list.id}`;

        const body = {
            submission_list_items_ids: submission_list_items_ids,
            supplementary_items_ids: supplementary_items_ids
        }
        body[key] = value;

        fetch(url + '.json', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then(data => {
              dispatch(setBlueprintImages(data.submission_list_items));
              dispatch(setSubmissionList({ ...data }))
              dispatch(setShowSuccessFlashMessage(true))
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}

export const recalculatePricing = () => (dispatch, getState) => {
    const { submission_list, companyId } = getState();

    const url = `/backoffice/companies/${companyId}/submission_lists/pricing/recalculate/${submission_list.id}`;

    fetch(url + '.json', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
    })
      .then((res) => {
          if (!res.ok)
              throw Error("An error occour during saving data on the database");
          else
              return res.json()
      })
      .then(data => {
          dispatch(setBlueprintImages(data.submission_list_items));
          dispatch(setSubmissionList({ ...data }))
          dispatch(setShowSuccessFlashMessage(true))
      })
      .catch((error) => {
          console.error("ERROR:", error);
          dispatch(setShowErrorModal(true));
      });
}

export const importGradingImages = (submissionListItemId) => (dispatch, getState) => {
    const { blueprintImages, submission_list, companyId } = getState();

    if (submission_list.items_count > 0 && !isInAClosingState(submission_list)) {
        let url = `/backoffice/companies/${companyId}/submission_lists/import_grading_images/${submission_list.id}.json`;

        if (submissionListItemId) {
            url = url + `?submission_list_item_id=${submissionListItemId}`;
            dispatch({type: 'LOADING_IMAGE', payload: { submissionListItemId: submissionListItemId }})
        } else {
            dispatch({type: 'LOADING_IMAGES'})
        }


        fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
        })
          .then((res) => {
              if (!res.ok)
                  throw Error(res.status === 503 ? "deployment in progress" : "An error occour during updating images on the database");
              else
                  return res.json()
          })
          .then(data => {
              const urls = data.urls

              let newBlueprintImages = blueprintImages.map((blueprintImage) => {
                  if (urls[blueprintImage.submission_list_item_id] && !blueprintImage.rejected && blueprintImage.grading) {
                      let newBlueprintImage = { ...blueprintImage }
                      newBlueprintImage["grading"] = { ...blueprintImage.grading}

                      if (urls[blueprintImage.submission_list_item_id]) {
                          newBlueprintImage["grading"]["graded_image_file_name"] = urls[blueprintImage.submission_list_item_id]["graded_image_file_name"];
                          newBlueprintImage["grading"]["graded_back_image_file_name"] = urls[blueprintImage.submission_list_item_id]["graded_back_image_file_name"];
                          newBlueprintImage["grading"]["thumb_graded_image_url"] = urls[blueprintImage.submission_list_item_id]["thumb_graded_image_url"];
                          newBlueprintImage["grading"]["thumb_graded_back_image_url"] = urls[blueprintImage.submission_list_item_id]["thumb_graded_back_image_url"];
                          newBlueprintImage["grading"]["xx_large_graded_image_url"] = urls[blueprintImage.submission_list_item_id]["xx_large_graded_image_url"];
                          newBlueprintImage["grading"]["xx_large_graded_back_image_url"] = urls[blueprintImage.submission_list_item_id]["xx_large_graded_back_image_url"];
                          newBlueprintImage["grading"]["is_valid"] = urls[blueprintImage.submission_list_item_id]["is_valid"];
                      }

                      return newBlueprintImage
                  }
                  return blueprintImage
              })

              let newSubmissionList = { ...submission_list };
              newSubmissionList['state'] = data.submission_list_state;
              
              dispatch(setSubmissionList(newSubmissionList));
              dispatch(setBlueprintImages(newBlueprintImages));
              dispatch({type: 'LOADING_IMAGES_COMPLETED'});
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
              if (error.toString().indexOf("deployment in progress") > -1) {
                  dispatch(setAdditionalErrorMessage(DEPLOYMENT_IN_PROGRESS_ERROR_MESSAGE));
                  removeHtmlElementClass(document, 'deploy_alert', 'd-none');
                  addHtmlElementClass(document, 'deploy_alert', 'd-flex');
                  addHtmlElementClass(document, 'start_deploy_btn', 'd-none');
              }
              dispatch({type: 'LOADING_IMAGES_COMPLETED'});
          });
    }
}

export const selectCurrentBlueprintImage = (products, railsEnv, defects) => (dispatch, getState) => {
    const { currentIndex, blueprintImages, submission_list, showZoomImg } = getState()

    if (!showZoomImg && (products === null ||
        (products[currentIndex].rejected === null && (products[currentIndex].state === 'raw' ||
          (products[currentIndex].state === 'regrading' && products[currentIndex].current_submission_list_id === submission_list.id)))))
        dispatch(openGradingModal((blueprintImages[currentIndex].product_id ? blueprintImages[currentIndex].product_id : null),
          (blueprintImages[currentIndex].label_language ? blueprintImages[currentIndex].label_language : null),
          blueprintImages[currentIndex], currentIndex, railsEnv, defects,
          (blueprintImages[currentIndex].current_grading ? blueprintImages[currentIndex].current_grading : null)))
}

export const clearBlueprintImageToGrade = () => ({
      type: 'CLEAR_GRADING_MODAL'
  }
)

export const getBlueprintImages = (perPage) => (dispatch, getState) => {
    const { page, filters, environment, submission_list, companyId } = getState();
    const per_page = isDefined(perPage) && perPage > 0 ? perPage : DEFAULT_PER_PAGE_PARAM;
    dispatch({type: 'LOADING'})

    let url = ''
    switch (environment) {
        case 'backoffice':
            url = `/backoffice/companies/${companyId}/blueprint_images.json?page=${page}&per_page=${per_page}`;
            break;
        case 'advanced_search':
            url = `/blueprint_images/advanced_search.json?page=${page}&per_page=${per_page}`;
            break;
        case 'submission_lists':
            url = `/backoffice/companies/${companyId}/submission_lists/${submission_list.id}.json?page=${page}&per_page=${per_page}`;
            break;
        default:
            url = `/blueprint_images/advanced_search.json?page=${page}&per_page=${per_page}`;
            break;

    }

    Object.entries(filters).forEach(([fieldName, fieldValue]) => {
        url += `&${fieldName}=${fieldValue}`
    })

    fetch(url)
      .then((res) => {
          if (!res.ok)
              throw Error("An error occour during getting data from database");
          else
              return res.json()
      })
      .then(data => {
          dispatch(appendBlueprintImages(environment === 'submission_lists' ? data.submission_list_items : data.blueprint_images, per_page));
          if (environment === 'submission_lists') {
              dispatch(setSubmissionList({ ...submission_list, supplementary_items: data.supplementary_items }))
              dispatch(setSubmissionListItemsIds(data.submission_list_items_ids));
              dispatch(setSupplementaryItemsIds(data.supplementary_items_ids));
          }
          dispatch({type: 'LOADING_COMPLETED'})
      })
      .catch((error) => {
          dispatch({type: 'LOADING_COMPLETED'})
          dispatch(setBlueprintImagesCount(0));
          console.error("ERROR:", error);
          dispatch(setShowErrorModal(true));
      });
}


export const resetFilters = (perPage) => (dispatch, getState) => {
    const { environment, submission_list, initialFilters, companyId } = getState();
    const per_page = isDefined(perPage) && perPage > 0 ? perPage : DEFAULT_PER_PAGE_PARAM;

    dispatch({type: 'RESET_FILTERS'})
    dispatch(getExpansions(initialFilters.game_id, '', '', ''));
    dispatch(getEras(initialFilters.game_id, '', '', ''));
    dispatch(getNewOptionsForFilters('', '', initialFilters.game_id));

    dispatch({type: 'LOADING'})
    dispatch(resetBlueprintImages());
    dispatch(setBlueprintImagesCount(null));

    let url = ''
    switch (environment) {
        case 'backoffice':
            url = `/backoffice/companies/${companyId}/blueprint_images.json?page=1&per_page=${per_page}`;
            break;
        case 'advanced_search':
            url = `/blueprint_images/advanced_search.json?page=1&per_page=${per_page}`;
            break;
        case 'submission_lists':
            url = `/backoffice/companies/${companyId}/submission_lists/${submission_list.id}.json?page=1&per_page=${per_page}`;
            break;
        default:
            url = `/blueprint_images/advanced_search.json?page=1&per_page=${per_page}`;
            break;

    }

    fetch(url)
      .then((res) => {
          if (!res.ok)
              throw Error("An error occour during getting data from database");
          else
              return res.json()
      })
      .then(data => {
          dispatch(appendBlueprintImages(environment === 'submission_lists' ? data.submission_list_items : data.blueprint_images, per_page));
          if (environment === 'submission_lists') {
              dispatch(setSubmissionList({ ...submission_list, supplementary_items: data.supplementary_items }))
              dispatch(setSubmissionListItemsIds(data.submission_list_items_ids));
              dispatch(setSupplementaryItemsIds(data.supplementary_items_ids));
          }
          $('.select2-custom').val('').trigger('change.select2');
          dispatch({type: 'LOADING_COMPLETED'})
      })
      .catch((error) => {
          dispatch({type: 'LOADING_COMPLETED'})
          dispatch(setBlueprintImagesCount(0));
          console.error("ERROR:", error);
          dispatch(setShowErrorModal(true));
      });
}


export const searchBlueprintImages = (perPage, doNotIncrementSearchCount) => (dispatch, getState) => {
    const { filters, environment, searchEnabled, submission_list, companyId } = getState();
    const per_page = isDefined(perPage) && perPage > 0 ? perPage : DEFAULT_PER_PAGE_PARAM;

    if (searchEnabled && !filters.name || !isNaN(Number(filters.name)) || filters.name.toString().trim().length >= 1) {
        if (!doNotIncrementSearchCount)
            dispatch({type: 'INCREMENT_SEARCH_COUNT'})
        dispatch({type: 'LOADING'})
        dispatch(disableSearch());
        dispatch(resetBlueprintImages());
        dispatch(setBlueprintImagesCount(null));

        let url = ''
        switch (environment) {
            case 'backoffice':
                url = `/backoffice/companies/${companyId}/blueprint_images.json?page=1&per_page=${per_page}`;
                break;
            case 'advanced_search':
                url = `/blueprint_images/advanced_search.json?page=1&per_page=${per_page}`;
                break;
            case 'submission_lists':
                url = `/backoffice/companies/${companyId}/submission_lists/${submission_list.id}.json?page=1&per_page=${per_page}`;
                break;
            default:
                url = `/blueprint_images/advanced_search.json?page=1&per_page=${per_page}`;
                break;
        }

        Object.entries(filters).forEach(([fieldName, fieldValue]) => {
            if (!['release_year', 'release_month', 'release_day'].includes(fieldName)) {
                let parsedValue = fieldValue;
                if (fieldName === 'code')
                    parsedValue = fieldValue.replaceAll('#', '[?]');
                else if (fieldName === 'name')
                    parsedValue = fieldValue.replaceAll('&', '[?]')
                else if (fieldName === 'sort_by') {
                    if (parsedValue === 'image_hashes' && !isDefined(filters.image_hashes))
                        parsedValue = '';
                    else if (isDefined(filters.image_hashes) && parsedValue !== 'image_hashes')
                        parsedValue = 'image_hashes';
                }
                url += `&${fieldName}=${parsedValue}`;
            }
        })

        fetch(url)
          .then((res) => {
              dispatch(enableSearch());
              if (!res.ok)
                  throw Error("An error occour during getting data from database");
              else
                  return res.json()
          })
          .then(data => {
              dispatch(appendBlueprintImages(environment === 'submission_lists' ? data.submission_list_items : data.blueprint_images, per_page));
              if (environment === 'submission_lists') {
                  dispatch(setSubmissionList({ ...submission_list, supplementary_items: data.supplementary_items }))
                  dispatch(setSubmissionListItemsIds(data.submission_list_items_ids));
                  dispatch(setSupplementaryItemsIds(data.supplementary_items_ids));
              }
              dispatch({type: 'LOADING_COMPLETED'})
              if (environment !== 'submission_lists')
                  dispatch(setBlueprintImagesCount(data.blueprint_images_count));
              else
                  dispatch(setBlueprintImagesCount(data.submission_list_items_ids.length + data.supplementary_items_ids.length));
          })
          .catch((error) => {
              dispatch({type: 'LOADING_COMPLETED'})
              dispatch(setBlueprintImagesCount(0));
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
    }
}

export const setBlueprintImages = (blueprintImages) => ({
      type: 'SET_BLUEPRINT_IMAGES', payload: {blueprintImages}
  }
)

export const resetBlueprintImages = () => ({
      type: 'RESET_BLUEPRINT_IMAGES'
  }
)

export const setSubmissionList = (submissionList) => ({
      type: 'SET_SUBMISSION_LIST', payload: {submissionList}
  }
)

export const setSubmissionListsByBlueprintImage = (submissionLists) => ({
      type: 'SET_SUBMISSION_LISTS_BY_BLUEPRINT_IMAGE', payload: {submissionLists}
  }
)

export const setAvailableSubmissionLists = (submissionLists) => ({
      type: 'SET_AVAILABLE_SUBMISSION_LISTS', payload: {submissionLists}
  }
)

export const setShowSuccessFlashMessage = (show) => ({
      type: 'SET_SHOW_SUCCESS_FLASH_MESSAGE', payload: {show}
  }
)

export const setSuccessFlashMessage = (message) => ({
      type: 'SET_SUCCESS_FLASH_MESSAGE', payload: {message}
  }
)

export const setShowErrorModal = (show) => ({
      type: 'SET_SHOW_ERROR_MODAL', payload: {show}
  }
)

export const setAdditionalErrorMessage = (message) => ({
      type: 'SET_ADDITIONAL_ERROR_MESSAGE', payload: {message}
  }
)

export const setShowSuccessModal = (show) => ({
      type: 'SET_SHOW_SUCCESS_MODAL', payload: {show}
  }
)

export const setSuccessMessage = (show) => ({
      type: 'SET_SUCCESS_MESSAGE', payload: {show}
  }
)

export const selectNewBlueprintImage = (blueprintImageIndex) => ({
      type: 'SELECT_NEW_BLUEPRINT_IMAGE', payload: {blueprintImageIndex}
  }
)

export const setBlueprintImage2ShowLargeImage = (blueprintImage, blueprintImageIndex) => ({
      type: 'SET_BLUEPRINT_IMAGE_2_SHOW_LARGE_IMAGE', payload: {blueprintImage, blueprintImageIndex}
  }
)

export const setShowZoomImg = (show) => ({
      type: 'SET_SHOW_ZOOM_IMG', payload: {show}
  }
)

export const setEras = (eras) => ({
        type: 'SET_ERAS', payload: {eras}
    }
)

export const getEras = (game, released_at, edition) => (dispatch) => {
    const url = `/eras_for_filters?game_id=${game}&released_at=${released_at}&edition=${edition}`;

    dispatch({type: 'LOADING_ERAS'})

    fetch(url)
      .then(response => {
          dispatch({type: 'LOADING_ERAS_COMPLETED'})
          return response.json();
      })
        .then(data => {
            dispatch(setEras(data));
        });
}

export const setExpansions = (expansions) => ({
        type: 'SET_EXPANSIONS', payload: {expansions}
    }
)

export const getExpansions = (game, era, released_at, edition) => (dispatch) => {
    const url = `/expansions_for_filters?game_id=${game}&era_id=${era}&released_at=${released_at}&edition=${edition}`;

    dispatch({type: 'LOADING_EXPANSIONS'})

    fetch(url)
        .then(response => {
            dispatch({type: 'LOADING_EXPANSIONS_COMPLETED'})
            return response.json();
        })
        .then(data => {
            dispatch(setExpansions(data));
        });
}

export const setNewOptionsForFilters = (optionsForSelect) => ({
      type: 'SET_NEW_FILTERS', payload: {optionsForSelect}
  }
)

export const getNewOptionsForFilters = (era, expansion, game) => (dispatch, getState) => {
    const { copyright, edition, release_year, released_at, language_filter, rarity, version, illustrator, pokedex_number } = getState().filters

    const url = `/advanced_search_options_for_filters?era_id=${era}&expansion_id=${expansion}&game_id=${game}`;

    dispatch({type: 'LOADING_OTHER_FILTERS'})

    fetch(url)
      .then(response => {
          dispatch({type: 'LOADING_OTHER_FILTERS_COMPLETED'})
          return response.json();
      })
      .then(data => {
          dispatch(setNewOptionsForFilters(data));

          if (version && version !== "" && !data.versions.flat().includes(version))
              dispatch(setFilterParam('version', ""))
          if (rarity && rarity !== "" && !data.rarities.flat().includes(rarity))
              dispatch(setFilterParam('rarity', ""))
          if (language_filter && language_filter !== "" && !data.languages.flat().includes(language_filter))
              dispatch(setFilterParam('language_filter', ""))
          if (release_year && release_year !== "" && !data.release_years.flat().includes(release_year)) {
              dispatch(setFilterParam('release_year', ""));
              dispatch(setFilterParam('release_month', ""));
              dispatch(setFilterParam('release_day', ""));
              dispatch(setFilterParam('released_at', ""));
          }
          if (edition && edition !== "" && !data.editions.flat().includes(edition))
              dispatch(setFilterParam('edition', ""))
          if (copyright && copyright !== "" && !data.copyrights.flat().includes(copyright))
              dispatch(setFilterParam('copyright', ""))
          if (illustrator && illustrator !== "" && !data.illustrators.flat().includes(illustrator))
              dispatch(setFilterParam('illustrator', ""))
          if (pokedex_number && pokedex_number !== "" && !data.pokedex_numbers.flat().includes(pokedex_number))
              dispatch(setFilterParam('pokedex_number', ""))
      });
}

function parseReleaseDate(year, month, day) {
    if (year !== "" && month !== "" && day !== "")
        return year + "-" + month + "-" + day
    else if (year !== "" && month !== "")
        return year + "-" + month
    else if (year !== "" && day !== "")
        return year + "--" + day
    else if (month !== "" && day !== "")
        return month + "-" + day
    else if (year !== "")
        return year
    else if (month !== "")
        return "-" + month
    else if (day !== "")
        return "-" + day
    else return ""
}

export const setFilterValue = (fieldName, fieldValue) => (dispatch, getState) => {
    const { game_id, era_id, expansion_id, release_year, release_month, release_day } = getState().filters

    switch (fieldName) {
        case 'name':
            dispatch(setFilterParam(fieldName, fieldValue));
            // debouncedCallFunction(() => {
            //     dispatch(searchBlueprintImages())
            // })
            return;
        case 'collector_number':
            dispatch(setFilterParam(fieldName, fieldValue));
            // debouncedCallFunction(() => {
            //     dispatch(searchBlueprintImages())
            // })
            return;
        case 'pokedex_number':
            dispatch(setFilterParam(fieldName, fieldValue));
            // debouncedCallFunction(() => {
            //     dispatch(searchBlueprintImages())
            // })
            return;
        case 'game_id':
            dispatch(setFilterParam(fieldName, fieldValue));
            dispatch(setFilterParam('era_id', ''));
            dispatch(setFilterParam('expansion_id', ''));
            dispatch(getEras(fieldValue, '', '' ));
            dispatch(getExpansions(fieldValue, era_id, '', ''));
            dispatch(getNewOptionsForFilters(era_id, expansion_id, fieldValue));
            // dispatch(searchBlueprintImages())
            return
        case 'era_id':
            dispatch(setFilterParam(fieldName, fieldValue));
            dispatch(setFilterParam('expansion_id', ''));
            dispatch(getExpansions(game_id, fieldValue, '', ''));
            dispatch(getNewOptionsForFilters(fieldValue, expansion_id, game_id));
            // dispatch(searchBlueprintImages())
            return
        case 'expansion_id':
            dispatch(setFilterParam(fieldName, fieldValue));
            dispatch(getNewOptionsForFilters(era_id, fieldValue, game_id));
            // dispatch(searchBlueprintImages());
            return
        case 'release_year':
            dispatch(setFilterParam(fieldName, fieldValue));
            if (fieldValue === "") {
                dispatch(setFilterParam('release_month', ""));
                dispatch(setFilterParam('release_day', ""));
            }
            const releaseDateByYear = parseReleaseDate(fieldValue, fieldValue !== "" ? release_month : "", fieldValue !== "" && release_month !== "" ? release_day : "")
            dispatch(setFilterParam('released_at', releaseDateByYear));
            // dispatch(searchBlueprintImages())
            return
        case 'release_month':
            dispatch(setFilterParam(fieldName, fieldValue));
            if (fieldValue === "")
                dispatch(setFilterParam('release_day', ""));
            const releaseDateByMonth = parseReleaseDate(release_year, fieldValue, fieldValue !== "" ? release_day : "")
            dispatch(setFilterParam('released_at', releaseDateByMonth));
            // dispatch(searchBlueprintImages())
            return
        case 'release_day':
            dispatch(setFilterParam(fieldName, fieldValue));
            dispatch(setFilterParam('released_at', parseReleaseDate(release_year, release_month, fieldValue)));
            // dispatch(searchBlueprintImages())
            return
        default:
            dispatch(setFilterParam(fieldName, fieldValue));
            // dispatch(searchBlueprintImages())
            if (['sort_by', 'sorting_direction'].includes(fieldName)) {
                dispatch(enableSearch())
                dispatch(searchBlueprintImages());
            }
            return
    }
}

export const setBlueprintInfo2PrintOnLabel = (newBlueprintInfo2PrintOnLabel) => ({
      type: 'SET_BLUEPRINT_INFO_TO_PRINT_ON_LABEL', payload: {newBlueprintInfo2PrintOnLabel}
  }
)

export const setMode = (mode) => ({
      type: 'SET_MODE', payload: {mode}
  }
)

export const setImage = (fieldName, fieldValue) => ({
      type: 'SET_IMAGE', payload: { fieldName: fieldName, fieldValue: fieldValue}
  }
)


export const setBlueprintImageParam = (blueprintImage, key, value) => ({
    type: 'SET_BLUEPRINT_IMAGE', payload: { blueprintImageId: blueprintImage.id, key: key, value: value }
})


export const setShowFullScreenLoadingOverlay = (value) => ({
    type: 'SET_SHOW_FULL_SCREEN_LOADING_OVERLAY', payload: { value: value }
})



export const setBlueprintImage2AddOnSubmissionList = (blueprintImage) => ({
      type: 'SET_BLUEPRINT_IMAGE_TO_ADD_ON_SUBMISSION_LIST', payload: {blueprintImage}
  }
)


// Funzione che permette di aggiungere la carta selezionata dall'utente sull'interfaccia grafica alla sua
// my collection, nelle quantità da lui specificate
export const addCardToMyCollection = (blueprintImage) => (dispatch) => {

        const body = {
            game_id: blueprintImage.game_id,
            items: [
                {
                    id: blueprintImage.id,
                    blueprint_id: blueprintImage.blueprint_id,
                    language: convertLanguage(blueprintImage.language),
                    quantity: blueprintImage.my_collection_quantity ? blueprintImage.my_collection_quantity : 1,
                },
            ],
        };

        if (parseInt(blueprintImage.my_collection_quantity) > 30)
            dispatch(setShowFullScreenLoadingOverlay(true))

        const url = "/my_collections";

        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        })
          .then((res) => {
              if (!res.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return res.json()
          })
          .then((data) => {
              dispatch(setShowFullScreenLoadingOverlay(false))
              dispatch(setShowSuccessModal(true))
              dispatch(setSuccessMessage({
                  message: I18n.t('js.common.actionsWithCards.successAddTO'),
                  linkTo: `/my_collections/${data.id}/edit`,
                  linkContent: 'collection'
              }))
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
};


// Funzione che permette di aggiungere la carta corrente alla wishlist dell'utente
export const addCardToWishlist = (blueprintImage) => (dispatch) => {

        const url = "/wishlists";

        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ items: [blueprintImage.id] }),
        }).then((res) => {
            if (!res.ok)
                throw Error("An error occour during saving data on the database");
            else
                return res.json()
        })
          .then((data) => {
              dispatch(setBlueprintImageParam(blueprintImage, 'already_in_wishlist', data.id))
              dispatch(setSuccessFlashMessage(I18n.t('js.indexCardPage.productAddedToWishlist')))
              dispatch(setShowSuccessFlashMessage(true))
          })
          .catch((error) => {
              console.error("ERROR:", error);
              dispatch(setShowErrorModal(true));
          });
}



// Funzione che permette all'utente di conoscere le offerte dei prodotti in vendita relativi alla carta selezionata
// sull'interfaccia grafica
export const viewOffers = (blueprintImage) => (dispatch, getState) => {
    window.location = `/products/${blueprintImage.id}`
}

const debouncedCallFunction = debounce((f) => f(), 1000)